import { SsbRateMode } from '../enums/SsbRateMode.enum';

export const SSB_RACES = ['Black', 'White', 'Latinx', 'Other', 'Asian', 'race_not_recorded'] as const;

export type SsbRace = (typeof SSB_RACES)[number];

export interface SsbRaceResult {
  in_box: number;
  indeterminate: number;
  // cases with a known outcome (within-box) or the group's population (per-capita)
  denominator: number | null;
  with_outcome: number | null;
  // share of the denominator for within-box, per 100k for per-capita
  rate: number | null;
  relative_risk: number | null;
  excess: number | null;
}

export interface SsbReferenceGroupResult {
  racial_reference_group: string;
  // keyed by race, aggregate groups such as "non-Black" are sent alongside the races
  results_by_race: Partial<Record<string, SsbRaceResult>>;
}

export interface SsbComparisonResult {
  analysis_id: number | string;
  comparison_mode: SsbRateMode;
  results_by_racial_reference_group: SsbReferenceGroupResult[];
}

export interface SsbAnalysisResult {
  analysis_results: SsbComparisonResult[];
}
